const Cookies = window.Cookies;
const cookieDomain = process.env.VUE_APP_cookie_domain;
import systemConfig from './config'
const getCookie$ = cname => {
  return Cookies.get(cname) || "";
}
const getRandomId$ = (name = '') => {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return name ? name + '-' + uuid : uuid;
}
const toJson$ = msg => {
  let result = {};
  try {
    if (msg === "pong") {
      result = msg;
    } else {
      result = typeof msg === "object" ? msg : JSON.parse(msg);
    }
  } catch (e) {
    console.error([e, null]);
  }
  return result;
}
const getFormateDate$ = (fmt, date) => {
  var o = {
    "M+": date.getMonth() + 1,               //月份
    "d+": date.getDate(),                    //日
    "h+": date.getHours(),                   //小时
    "m+": date.getMinutes(),                 //分
    "s+": date.getSeconds(),                 //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds()             //毫秒
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length))
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))
  return fmt;
}
const copyObj$ = (data) => {
  return JSON.parse(JSON.stringify(data))
}

const setCookie$ = ({ key, value, expires, domain, path = '/' }) => {
  Cookies.set(key, value, { path, domain, expires });
}
const setCookieIos$ = ({ key, value, expires, path = '/' }) => {
  Cookies.set(key, value, { path, expires });
}
const clearAllCookies$ = () => {
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    let eqPos = cookie.indexOf("=");
    let name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    Cookies.remove(name, { domain: cookieDomain })
  }
}

const formatUrlWithToken$ = function (url) {
  let token = getCookie$("token");
  let customerId = getCookie$("teamId");
  if (/\?/.test(url)) {
    url = `${url}&token=${token}`;
  } else {
    url = `${url}?&token=${token}`;
  }
  if (!/\/nuwa-statics\//.test(url)) {
    url = `${url}&customerId=${customerId}`
  }
  return url;
}
//判断是否是移动端设备
const isMobile$ = () => {
  return !!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
}

const getI18nLabel$ = function (obj, langKey = "langCode", labelkey = "name") {
  const langCode = Cookies.get("langCode");
  let lang;
  if (obj instanceof Array) {
    lang = obj.find(item => item[langKey] === langCode);
  } else if (obj instanceof Object) {
    lang = obj[langCode];
  }
  if (lang) {
    if (typeof lang === "string") {
      return lang;
    } else if (lang instanceof Object) {
      return lang[labelkey] || "";
    }
  } else {
    return "";
  }
}
const diskSize$ = function (num, format) {
  if (num == 0) return '0 B';
  var k = 1024; //设定基础容量大小
  var sizeStr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']; //容量单位
  var i = 0; //单位下标和次幂
  var formatIndex = sizeStr.findIndex(item => format && item === format.toUpperCase());
  if (formatIndex >= 0) {
    i = formatIndex
  } else {
    for (var l = 0; l < 8; l++) {   //因为只有8个单位所以循环八次
      if (num / Math.pow(k, l) < 1) { //判断传入数值 除以 基础大小的次幂 是否小于1，这里小于1 就代表已经当前下标的单位已经不合适了所以跳出循环
        break; //小于1跳出循环
      }
      i = l; //不小于1的话这个单位就合适或者还要大于这个单位 接着循环
    }
    // 例： 900 / Math.pow(1024, 0)  1024的0 次幂 是1 所以只要输入的不小于1 这个最小单位就成立了；
    //     900 / Math.pow(1024, 1)  1024的1次幂 是1024  900/1024 < 1 所以跳出循环 下边的 i = l；就不会执行  所以 i = 0； sizeStr[0] = 'B';
    //     以此类推 直到循环结束 或 条件成立
  }
  return (num / Math.pow(k, i)).toFixed(2) + ' ' + sizeStr[i];  //循环结束 或 条件成立 返回字符
}
const getNuwaWebsite = function(){
    return getI18nLabel$(systemConfig.nuwaWebsiteUrl, 'langCode', 'url')
}

export default {
  toJson$,
  copyObj$,
  setCookie$,
  getCookie$,
  getRandomId$,
  getFormateDate$,
  clearAllCookies$,
  formatUrlWithToken$,
  setCookieIos$,
  isMobile$,
  getI18nLabel$,
  diskSize$,
  getNuwaWebsite
}
